import React, { useState } from "react";
import { Modal, Button, Alert, Form } from "react-bootstrap";
import './ModalConsentGate.css';
import { linkOESDGSE, linkDPImprint } from '../../Consts';

const openWindowNewSite = (site) => {
    if (site === 'dgse') {
        window.open(linkOESDGSE, '_blank');
    }
    if (site === 'imprint') {
        window.open(linkDPImprint + "imprint", '_blank');
    }
    if (site === 'dp') {
        window.open(linkDPImprint + "dp", '_blank');
    }
}

function ModalConsentGate({ children }) {
    const [status, setStatus] = useState(null);
    const [hasReadHints, setHasReadHints] = useState(false);

    if (status === "declined") {
        return (
            // <div className="container py-5">
            //     <Alert variant="danger">
            //         <Alert.Heading>Nutzung nicht möglich</Alert.Heading>
            //         <p>
            //             Ohne Zustimmung zu den Hinweisen kann dieses Werkzeug nicht verwendet
            //             werden.
            //         </p>
            //         <p className="mb-0">
            //             Du kannst dieses Fenster nun schließen.
            //         </p>
            //     </Alert>
            // </div>
            <div className="container min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#ffffff', boxShadow: 'none', border: 'none' }}>
                <div className="col-12 col-md-8 col-lg-5">
                    <div className="card shadow border-0 rounded-4 text-center">
                        <div className="card-body p-5">
                            <div className="display-4 mb-3" aria-hidden="true">
                                🚫
                            </div>

                            <h1 className="h3 mb-3">
                                Nutzung leider nicht möglich
                            </h1>

                            <p className="text-muted mb-4">
                                Ohne Ihre Zustimmung zu den Hinweisen kann dieses Werkzeug nicht verwendet werden.
                            </p>

                            <div className="alert alert-light border mb-0">
                                Sie können dieses Browser-Tab nun manuell schließen.
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <Modal
                show={status === null}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Wichtige Hinweise zur Nutzung</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ul>
                        <li>
                            Hochgeladene Dokumente können personenbezogene Daten enthalten. Laden Sie nur erforderliche Dokumente hoch, zu deren Verarbeitung Sie berechtigt sind, und pseudonymisieren Sie Daten nach Möglichkeit.
                        </li>
                        <li>
                            Die Verarbeitung und Speicherung erfolgen ausschließlich lokal auf Ihrem Endgerät. Es werden keine Daten an externe Server oder Dritte übertragen. Schützen Sie Dokumente und Ergebnisse vor unbefugtem Zugriff. Bei Nutzung eines privaten Endgeräts ist die erforderliche Genehmigung der Schulleitung zu beachten.
                        </li>

                    </ul>
                    {/* <p>
                        Ohne Ihre Zustimmung zu den obigen Hinweisen kann das Werkzeug nicht verwendet werden.
                    </p> */}

                    <Form.Check className="d-flex align-items-center gap-2 mt-3 consent-check">
                        <Form.Check.Input
                            id="consent-read-hints"
                            type="checkbox"
                            checked={hasReadHints}
                            onChange={(event) => setHasReadHints(event.target.checked)}
                            className="mt-0"
                        />

                        <Form.Check.Label
                            htmlFor="consent-read-hints"
                            className="mb-0"
                        >
                            Ich habe die Hinweise gelesen, verstanden und akzeptiert.
                        </Form.Check.Label>
                    </Form.Check>

                    <p>
                        <span className="text-nowrap">
                            Sehen Sie ferner die{" "}
                            <Button
                                variant="link"
                                className="p-0 align-baseline"
                                onClick={() => openWindowNewSite("dp")}
                            >
                                Datenschutzerklärung
                            </Button>{" "}
                            und das{" "}
                            <Button
                                variant="link"
                                className="p-0 align-baseline"
                                onClick={() => openWindowNewSite("imprint")}
                            >
                                Impressum
                            </Button>
                            .
                        </span>                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setStatus("declined")}
                    >
                        Abbrechen
                    </Button>

                    <span
                        style={{
                            display: "inline-block",
                            cursor: hasReadHints ? "pointer" : "not-allowed"
                        }}
                    >

                        <Button
                            variant="primary"
                            disabled={!hasReadHints}
                            className="consent-accept-button"
                            onClick={() => setStatus("accepted")}
                        >
                            Bestätigen
                        </Button>
                    </span>
                </Modal.Footer>
            </Modal>

            {status === "accepted" && children}
        </>
    );
}

export default ModalConsentGate;